// @ts-nocheck
export const AEM_URL = 'https://publish-p43010-e175133.adobeaemcloud.com/';
